import {Tag} from 'antd';
import styles from './schemeUserLeaderboard.module.scss';

const RequirementRow = ({label, value, status}) => (
  <div className={styles.requirementRow}>
    <div className={styles.requirementDetails}>
      <div className={styles.requirementLabel}>{label}</div>
    </div>
    <div className={styles.requirementValue}>
      <Tag
        color={status ? 'success' : 'error'}
        className={styles.requirementTag}>
        {status ? 'Requirement met' : 'Not met'}
      </Tag>
      {value && <span className={styles.requirementNote}>{value}</span>}
    </div>
  </div>
);

export default RequirementRow;
